module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic-ext36.df55b7e.woff2";